/**
 * Case status snapshot domain entity.
 * Represents an available status for a case at a given point in time.
 */
export class CaseStatusSnapshotEntity {
  public id!: string;
  public categoryId!: number;
  public categoryName!: string;
  public color!: string;
  public displayName!: string;
  public isActive!: boolean;
  public name!: string;
  public sortOrder!: number;
  public sourceStatusId!: string;
}
